module.exports = __webpack_public_path__ + "am.675900ed80f847275ae3.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/am.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/am.svg
// module chunks = styles